module.exports = __webpack_public_path__ + "static/media/Phan_Huy_Nguyen.56e51226.jpg";